export function importLinkMap(professionSeoName) {
  return import(
    /* webpackChunkName: "profession-nav-links/[request]" */
    `~/config/professionNavLinks/${professionSeoName}.json`
  ).then((module) => module.default ?? module);
}
